export default __webpack_public_path__ + "static/media/empty-credit.343e000c.svg";